module.exports = __webpack_public_path__ + "static/img/02073cf015e308ce3acac414b2ad55f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/config_tool.png
// module id = pMjj
// module chunks = 1